import { useCallback, useEffect } from 'react';
import { PrimitiveAtom, useAtomValue, useSetAtom } from 'jotai';
import queryString from 'query-string';
import { updateUrl } from '@/utils';
import { encodeVisibleIndexes, applyVisibilityByIndex } from './utils';

export type CuboidClassesDeeplinkState = {
  shouldUpdateUrl: boolean;
  cuboidClassByIdAtom: PrimitiveAtom<{ [id: string]: { isVisible?: boolean } } | undefined>;
};

export const useCuboidClassesDeeplink = (state: CuboidClassesDeeplinkState) => {
  const { shouldUpdateUrl, cuboidClassByIdAtom } = state;

  const cuboidClassById = useAtomValue(cuboidClassByIdAtom);
  const setCuboidClassById = useSetAtom(cuboidClassByIdAtom);

  useEffect(() => {
    if (shouldUpdateUrl) {
      updateUrl('visibleCuboidClasses', encodeVisibleIndexes(cuboidClassById));
    }
  }, [shouldUpdateUrl, cuboidClassById]);

  const applyFromParsed = useCallback(
    (parsed: queryString.ParsedQuery<string>) => {
      if (parsed.visibleCuboidClasses !== undefined) {
        setCuboidClassById((current) =>
          applyVisibilityByIndex(current, parsed.visibleCuboidClasses)
        );
      }
    },
    [setCuboidClassById]
  );

  return { applyFromParsed };
};
